const skills = [
  {
    icon: 'ri-shield-star-line',
    title: 'Лидерство',
    desc: 'Как руководителю влиять на команду, формировать доверие и добиваться результата не только за счёт должностных полномочий.',
  },
  {
    icon: 'ri-task-line',
    title: 'Постановка задач',
    desc: 'Как ставить задачи понятно, конкретно и с измеримым результатом, чтобы сотрудник точно понимал, что от него ожидается.',
  },
  {
    icon: 'ri-share-forward-line',
    title: 'Делегирование',
    desc: 'Как передавать ответственность сотрудникам и сохранять контроль над результатом без микроменеджмента.',
  },
  {
    icon: 'ri-check-double-line',
    title: 'Контроль',
    desc: 'Как контролировать выполнение задач через систему контрольных точек, а не постоянное вмешательство.',
  },
  {
    icon: 'ri-chat-check-line',
    title: 'Обратная связь',
    desc: 'Как давать обратную связь, которая меняет поведение сотрудника и помогает развивать его компетенции.',
  },
  {
    icon: 'ri-fire-line',
    title: 'Мотивация',
    desc: 'Как понимать мотивацию сотрудников и создавать условия для высокой вовлечённости и результативности.',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Управление конфликтами',
    desc: 'Как разбирать конфликты между сотрудниками, подразделениями и руководителями.',
  },
  {
    icon: 'ri-lightbulb-line',
    title: 'Принятие решений',
    desc: 'Как принимать решения в условиях ограниченной информации, неопределённости и давления.',
  },
  {
    icon: 'ri-message-3-line',
    title: 'Коммуникация',
    desc: 'Как выстраивать эффективные коммуникации с сотрудниками, коллегами и руководством.',
  },
  {
    icon: 'ri-refresh-line',
    title: 'Управление изменениями',
    desc: 'Как внедрять новые процессы и изменения, работая с сопротивлением команды.',
  },
  {
    icon: 'ri-team-line',
    title: 'Управленческие переговоры',
    desc: 'Как руководителю вести сложные переговоры с сотрудниками, коллегами, собственниками и руководством.',
  },
  {
    icon: 'ri-seedling-line',
    title: 'Развитие сотрудников',
    desc: 'Как формировать кадровый резерв, развивать сильных специалистов и выращивать будущих руководителей.',
  },
];

export default function ManagementSkills() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Какие управленческие навыки развивает программа
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Управленческая работа требует принципиально других компетенций, чем работа специалиста. Вот ключевые направления, которые мы развиваем в программах для руководителей.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {skills.map((skill, i) => (
            <div key={i} className="bg-gray-50 rounded-xl border border-gray-100 p-5 md:p-6 hover:border-teal-200 transition-colors group">
              <div className="w-11 h-11 bg-teal-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-teal-200 transition-colors">
                <i className={`${skill.icon} text-xl text-teal-700`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{skill.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{skill.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}